// eslint-disable-next-line import/prefer-default-export
export const unimedNegativeMarginProcedures = [
  '31401260',
  '30715210',
  '30715016',
  '30715016',
  '30214025',
  '30214025',
  '30725127',
  '30715024',
  '30215099',
  '30715016',
  '31403123',
  '30724279',
  '30715024',
  '30715113',
  '31401082',
  '30907080',
  '30715032',
  '31201148',
  '30213053',
  '31003281',
  '31003176',
  '30715024',
  '30502268',
  '30715229',
  '30805015',
  '31201148',
  '30906075',
  '31006060',
  '31002315',
  '30733073',
  '31202020',
  '31006051',
  '31007066',
  '31302025',
  '30214041',
  '30212014',
  '30718090',
  '60000511',
  '30501288',
  '31004075',
  '31201148',
  '30715024',
  '31302025',
  '40202054',
  '30710022',
  '30907110',
  '31103324',
  '30501288',
  '40202054',
  '30715180',
  '30212103',
  '30727162',
  '30804132',
  '30726280',
  '30212014',
  '31206115',
  '30913101',
  '30213053',
  '40202585',
  '30204062',
  '30101441',
  '30201020',
  '31206182',
  '31401260',
  '30602114',
  '30213045',
  '30908027',
  '30404061',
  '30501130',
  '30726042',
  '40202267',
  '30212090',
  '30501326',
  '31206034',
  '31203124',
  '30721237',
  '31307060',
  '30301270',
  '30913101',
  '31203116',
  '30735017',
  '30501326',
  '31303102',
  '60001038',
  '30205085',
  '31103200',
  '31005101',
  '31301126',
  '31203124',
  '30301181',
  '40813363',
  '30212081',
  '31202055',
  '31101240',
  '31306039',
  '31101259',
  '40202119',
  '31004202',
  '30502349',
  '30715016',
  '30205069',
  '31309151',
  '30602297',
  '90302265',
  '31403352',
  '30726190',
  '30601142',
  '30403081',
  '31301088',
  '30722594',
  '31602150',
  '30301190',
  '31008097',
  '31303226',
  '30726140',
  '30717140',
  '30735092',
  '31202071',
  '30501377',
  '30401062',
  '40811026',
  '41101227',
  '31301134',
  '31203078',
  '31104100',
  '31102298',
  '30715164',
  '60023058',
  '30724279',
  '30731100',
  '40202291',
  '30101107',
  '30202035',
  '30715016',
  '30204046',
  '30214017',
]
